import { loadStages, buildStageMaps } from "@/objects/stageLoader";

/**
 * Shared GlobalData (HrdcData) for the event services.
 *
 * Single source of truth: the hrdc_event DB Stage table (which differs from the
 * hrdc one — e.g. it has `bulkEventApplication`). Served by the event API's
 * /v1/en/console/stage/get-stages and cached client-side (see stageLoader), under
 * a SEPARATE cache namespace from the hrdc service.
 *
 * @param {string} apiUrl - The base API URL for the event service.
 */
// All event modules (e-Invoicing / Tax Summit / TPDIY / Stamp Duty) share the
// same backend API and the same hrdc_event DB.
const DEFAULT_EVENT_API_URL =
  process.env.VUE_APP_SERVICE_URL_HRDC_EINVOICING ||
  process.env.VUE_APP_SERVICE_URL_HRDC_TAX_SUMMIT ||
  process.env.VUE_APP_SERVICE_URL_HRDC_TPDIY ||
  process.env.VUE_APP_SERVICE_URL_HRDC_STAMP_DUTY;

export default class HrdcData {
  constructor(apiUrl = DEFAULT_EVENT_API_URL) {
    this.stagePriority = null;
    this.stageSlug = null;
    this.stageIndex = null;
    this.stageSlugToStageName = null;

    // `allStages` resolves to the STAGE_NAME -> id map; the four lookup maps above
    // are populated as a side effect once stages load.
    this.allStages = loadStages("hrdc_event", apiUrl).then((stages) => {
      const maps = buildStageMaps(stages);
      this.stagePriority = maps.stagePriority;
      this.stageSlug = maps.stageSlug;
      this.stageIndex = maps.stageIndex;
      this.stageSlugToStageName = maps.stageSlugToStageName;
      return maps.allStage;
    });
  }
}
